function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Add dropdown menu that you add onto any component.
 *
 * Similar to the context-actions package, accepts list of actions to create a dropdown menu.
 * Note: Does not support nested sub-menus.
 *
 * Usage:
 * let actions = [{
 *   title: 'My Action',
 *   action: () => { alert('My Action Clicked!') }
 *   icon: faPrint,         // Limited to FontAwesome icons for now.
 *   shortcut: Shortcut,        // Shortcut class instance
 *   group: ContextActions.groups.default,  // What group to group the context action with
 *   order: null                            // Int where to order within group
 * }];
 *
 * Usage:
 * 1. Auto bind click to open event to parent
 * <div>
 *   Click in this container
 *   <DropdownMenu actions={actions}/>
 * </div>
 *
 * 2. Control via prop
 * <div>
 *   DropdownMenu will not react to the click event if isShown prop is used
 *   <DropdownMenu actions={actions} isShown={isShown} />
 * </div>
 *
 */
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Popper } from "../popper/index.js";
import Menu from "./Menu.js";
import "./DropdownMenu.css";
import { jsx as _jsx } from "react/jsx-runtime";
class DropdownMenu extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "container", void 0);
    _defineProperty(this, "parent", void 0);
    _defineProperty(this, "popper", void 0);
    _defineProperty(this, "isOpen", void 0);
    this.handleClick = this.handleClick.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
    this.handleExited = this.handleExited.bind(this);
    this.container = /*#__PURE__*/React.createRef();
    this.parent = null;
    this.popper = /*#__PURE__*/React.createRef();
    this.isOpen = false;
  }
  componentDidMount() {
    var isShown = this.props.isShown;
    if (isShown === null) {
      var _this$container$curre;
      if ((_this$container$curre = this.container.current) !== null && _this$container$curre !== void 0 && _this$container$curre.parentElement) {
        this.parent = this.container.current.parentElement;
        this.parent.addEventListener('click', this.handleClick);
      }
    } else if (isShown) {
      this.openMenu();
    }
  }
  componentDidUpdate(prevProps) {
    var isShown = this.props.isShown;
    if (prevProps.isShown !== isShown) {
      if (isShown !== null && isShown) {
        // https://github.com/reactjs/react-transition-group/issues/382
        window.requestAnimationFrame(() => {
          this.openMenu();
        });
      } else {
        this.closeMenu();
      }
    }
  }
  componentWillUnmount() {
    if (this.parent) {
      this.parent.removeEventListener('click', this.handleClick);
    }
  }
  closeMenu() {
    var _this$popper$current;
    (_this$popper$current = this.popper.current) === null || _this$popper$current === void 0 || _this$popper$current.hide();
  }
  openMenu() {
    if (this.popper.current && !this.isOpen) {
      this.popper.current.show();
      this.isOpen = true;
    }
  }
  scheduleUpdate() {
    var _this$popper$current2;
    (_this$popper$current2 = this.popper.current) === null || _this$popper$current2 === void 0 || _this$popper$current2.scheduleUpdate();
  }
  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.openMenu();
  }
  handleCloseMenu() {
    this.closeMenu();
  }
  handleExited() {
    this.isOpen = false;
    var onMenuClosed = this.props.onMenuClosed;
    onMenuClosed();
  }
  render() {
    var _this$props = this.props,
      actions = _this$props.actions,
      onMenuOpened = _this$props.onMenuOpened,
      popperClassName = _this$props.popperClassName,
      dataTestId = _this$props['data-testid'];
    var menuStyle = this.props.menuStyle;
    var _this$props2 = this.props,
      options = _this$props2.options,
      popperOptions = _this$props2.popperOptions;
    popperOptions = _objectSpread({
      placement: 'bottom'
    }, popperOptions);
    options = _objectSpread({
      separateKeyboardMouse: true
    }, options);
    return /*#__PURE__*/_jsx("div", {
      className: "menu-actions-listener",
      ref: this.container,
      "data-testid": dataTestId,
      children: /*#__PURE__*/_jsx(Popper, {
        ref: this.popper,
        options: popperOptions,
        className: classNames('menu-popper', popperClassName),
        onExited: this.handleExited,
        closeOnBlur: true,
        interactive: true,
        children: /*#__PURE__*/_jsx(Menu, {
          actions: actions,
          closeMenu: this.handleCloseMenu,
          onMenuOpened: onMenuOpened,
          options: options,
          menuStyle: menuStyle
        })
      })
    });
  }
}
_defineProperty(DropdownMenu, "defaultProps", {
  isShown: null,
  onMenuClosed() {
    // no-op
  },
  onMenuOpened() {
    // no-op
  },
  options: {},
  popperOptions: {},
  popperClassName: '',
  menuStyle: {},
  'data-testid': undefined
});
export default DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map